import { Autocomplete, Button, Input } from "src/components";
import crossIcon from "src/assets/cross.svg";
import { useToast } from "src/hooks/useToast";
import { useState } from "react";
import { getMedvolAdminUsers } from "src/services/employee-api";
import { generateCounterProductReport } from "src/services/reports-api"

const FeedbackReportFilters = ({
    onCloseModal,
    onSuccess,
}: {
    onCloseModal: () => void;
    onSuccess: () => void
}) => {
    const { toast } = useToast();
    const [isLoading, setIsLoading] = useState(false);
    const [feedbackGivenBy, setFeedbackGivenBy] = useState<any>(null);
    const [feedbackGivenTo, setFeedbackGivenTo] = useState<any>(null);
    const [fromDate, setFromDate] = useState<string>("");
    const [toDate, setToDate] = useState<string>("");

    const fetchEmployees = async () => {
        const data = getMedvolAdminUsers();
        return data;
    };

    const handleReportSubmit = async () => {
        if (!fromDate || !toDate) {
            toast({ description: "Please select from and to date", variant: "destructive" });
            return;
        }
        if (new Date(toDate) < new Date(fromDate)) {
            toast({ description: "To date cannot be before From date", variant: "destructive" });
            return;
        }
        setIsLoading(true);
        const payload = {
            "report_type": "feedback",
            "time_range": fromDate + "-" + toDate,
            "filters": {
                "feedback_given_by": feedbackGivenBy?.ucode || null,
                "feedback_given_to": feedbackGivenTo?.ucode || null,
            }
        }
        try {
            const response = await generateCounterProductReport(payload);
            toast({ description: "Report generation request sent successfully", variant: "default" });
            if (response?.data?.success) {
                onCloseModal();
                onSuccess();
            }
        } catch (error: any) {
            console.log(error);
            toast({ description: error?.response?.data?.message || "Failed to generate report", variant: "destructive" });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="flex flex-col gap-y-2 w-[400px] mx-auto bg-white p-4 border border-gray-300 shadow-lg rounded-lg">
            <div className="flex justify-between items-center">
                <p className="text-normal py-1 font-semibold text-[#1B1A1F]">Generate Report</p>
                <Button className="bg-transparent -mr-3" onClick={onCloseModal}>
                    <img src={crossIcon} alt="cross" className="w-5 h-5 font-bold invert cursor-pointer" />
                </Button>
            </div>
            <div className="flex flex-col gap-y-2 px-2">
                <div className="mb-2">
                    <label className="text-sm font-normal text-[#666666]">Feedback Given By</label>
                    <Autocomplete
                        onSelectionChange={(value: any) => { setFeedbackGivenBy(value) }}
                        placeholder="Select Employee"
                        inputClassName="w-full mt-2"
                        suggestionList={[]}
                        displayKey="name"
                        additionalDisplayKey="user_role.role"
                        defaultValue={feedbackGivenBy}
                        uniqueKey="ucode"
                        asyncListFunction={fetchEmployees}
                        isAsyncQuery={false}
                    />
                </div>
                <div className="mb-2">
                    <label className="text-sm font-normal text-[#666666]">Feedback Given To</label>
                    <Autocomplete
                        onSelectionChange={(value: any) => { setFeedbackGivenTo(value) }}
                        placeholder="Select Employee"
                        inputClassName="w-full mt-2"
                        suggestionList={[]}
                        displayKey="name"
                        additionalDisplayKey="user_role.role"
                        defaultValue={feedbackGivenTo}
                        uniqueKey="ucode"
                        asyncListFunction={fetchEmployees}
                        isAsyncQuery={false}
                    />
                </div>
                <div className="flex justify-between mt-2">
                    <div className="w-[45%]">From: <Input
                        enableArrows={false}
                        showIcon={false}
                        type="date"
                        placeholder="E-Way Bill Date"
                        value={fromDate ? fromDate.split("T")[0] : ""}
                        onChange={(e: any) => {
                            const dateValue = e.target.value;
                            const selectedDate = new Date(dateValue);

                            const now = new Date();

                            // Set time using UTC values
                            selectedDate.setUTCHours(now.getUTCHours());
                            selectedDate.setUTCMinutes(now.getUTCMinutes());
                            selectedDate.setUTCSeconds(now.getUTCSeconds());
                            selectedDate.setUTCMilliseconds(now.getUTCMilliseconds());

                            const formattedDate = selectedDate.toISOString();
                            setFromDate(formattedDate);
                        }}
                        min="2026-01-01"
                        max={new Date().toISOString().split("T")[0]}
                        className="w-full py-1 border border-gray-300 rounded-lg"
                    /></div>
                    <div className="w-[45%]">To: <Input
                        enableArrows={false}
                        showIcon={false}
                        type="date"
                        placeholder="E-Way Bill Date"
                        value={toDate ? toDate.split("T")[0] : ""}
                        onChange={(e: any) => {
                            const dateValue = e.target.value;
                            const selectedDate = new Date(dateValue);

                            const now = new Date();


                            selectedDate.setUTCHours(now.getUTCHours());
                            selectedDate.setUTCMinutes(now.getUTCMinutes());
                            selectedDate.setUTCSeconds(now.getUTCSeconds());
                            selectedDate.setUTCMilliseconds(now.getUTCMilliseconds());

                            const formattedDate = selectedDate.toISOString();
                            setToDate(formattedDate);
                        }}
                        min="2026-01-01"
                        max={new Date().toISOString().split("T")[0]}
                        className="w-full py-1 border border-gray-300 rounded-lg"
                    /></div>
                </div>

            </div>

            <div className="gap-x-2">
                <Button isLoading={isLoading} loaderSize="small" disabled={isLoading} className="text-white w-full bg-[#8051FF] mt-4" onClick={handleReportSubmit}>
                    Submit
                </Button>

            </div>
        </div >
    );
};

export default FeedbackReportFilters;
